import React from 'react';

import LinkIcon from '@atlaskit/icon/core/link';

import { ProductKeys, useProductConfigs } from '../../constants/products';

export const FederatedIcon = ({
	product,
	resourceType,
}: {
	product?: string;
	resourceType?: string;
}): React.JSX.Element => {
	const products = useProductConfigs();
	let productKey;
	if (product === 'google' && resourceType === 'email') {
		productKey = ProductKeys.Gmail;
	} else if (product === 'microsoft' && resourceType === 'email') {
		productKey = ProductKeys.OutlookMail;
	}

	if (!productKey) {
		return <LinkIcon color="currentColor" spacing="spacious" label="" />;
	}

	let IconComponent = products[productKey]?.SearchResultIcon;
	return IconComponent ? (
		<IconComponent label="" />
	) : (
		<LinkIcon color="currentColor" spacing="spacious" label="" />
	);
};
